"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockSearchContent = {
    data: [
        {
            displayName: 'SQL Injection 1',
            description: 'Java',
            language: 'Java',
            contentType: 'Lesson',
            assignedToMe: false,
            status: 'started',
            url: '/courses/java/lessons/sql_injection',
        },
        {
            displayName: 'XXE Processing Video',
            description: null,
            language: null,
            contentType: 'Video',
            assignedToMe: true,
            status: 'not_started',
            url: 'some-uuid-asdkskj34kdsasdadsad23242jfd4',
        },
        {
            displayName: 'Cookie hijacking',
            description: null,
            language: null,
            contentType: 'Video',
            assignedToMe: true,
            status: 'not_started',
            url: 'some-uuid-asdkskj34kdsf234243ddd244',
        },
        {
            displayName: 'CSRF attack',
            description: null,
            language: null,
            contentType: 'Video',
            assignedToMe: true,
            status: 'not_started',
            url: 'some-uuid-asdkskj34kdsfjkdskjfd4',
        },
        {
            displayName: 'Java Advanced 1',
            description: '',
            language: '',
            contentType: 'Course',
            assignedToMe: false,
            status: 'completed',
            url: '/app/learn/courseUuid?heruih4398eiwejdew',
        },
        {
            displayName: 'Fundamental Challenge for Java 1',
            description: '',
            language: '',
            contentType: 'Challenge',
            assignedToMe: false,
            status: 'not_started',
            url: '/app/play/challengeUuid?heruih4398eiwejdew',
        },
        {
            displayName: 'SQL Injection 2',
            description: 'Java',
            language: 'Java',
            contentType: 'Lesson',
            assignedToMe: false,
            status: 'started',
            url: '/courses/java/lessons/sql_injection',
        },
        {
            displayName: 'XXE Processing 2',
            description: '.Net',
            language: '.Net',
            contentType: 'Lesson',
            assignedToMe: true,
            status: 'completed',
            url: '/courses/dotnet/lessons/xxe_processing',
        },
        {
            displayName: 'Java Advanced 2',
            description: '',
            language: '',
            contentType: 'Course',
            assignedToMe: false,
            status: 'completed',
            url: '/app/learn/courseUuid?heruih4398eiwejdew',
        },
        {
            displayName: 'Fundamental Challenge for Java 2',
            description: '',
            language: '',
            contentType: 'Challenge',
            assignedToMe: false,
            status: 'not_started',
            url: '/app/play/challengeUuid?heruih4398eiwejdew',
        },
        {
            displayName: 'SQL Injection 3',
            description: 'Java',
            language: 'Java',
            contentType: 'Lesson',
            assignedToMe: false,
            status: 'started',
            url: '/courses/java/lessons/sql_injection',
        },
        {
            displayName: 'XXE Processing 3',
            description: '.Net',
            language: '.Net',
            contentType: 'Lesson',
            assignedToMe: true,
            status: 'completed',
            url: '/courses/dotnet/lessons/xxe_processing',
        },
        {
            displayName: 'Java Advanced 3',
            description: '',
            language: '',
            contentType: 'Course',
            assignedToMe: false,
            status: 'completed',
            url: '/app/learn/courseUuid?heruih4398eiwejdew',
        },
        {
            displayName: 'Fundamental Challenge for Java 4',
            description: '',
            language: '',
            contentType: 'Challenge',
            assignedToMe: false,
            status: 'not_started',
            url: '/app/play/challengeUuid?heruih4398eiwejdew',
        },
        {
            displayName: 'SQL Injection 4',
            description: 'Java',
            language: 'Java',
            contentType: 'Lesson',
            assignedToMe: false,
            status: 'started',
            url: '/courses/java/lessons/sql_injection',
        },
        {
            displayName: 'XXE Processing 4',
            description: '.Net',
            language: '.Net',
            contentType: 'Lesson',
            assignedToMe: true,
            status: 'completed',
            url: '/courses/dotnet/lessons/xxe_processing',
        },
        {
            displayName: 'Java Advanced 4',
            description: '',
            language: '',
            contentType: 'Course',
            assignedToMe: false,
            status: 'completed',
            url: '/app/learn/courseUuid?heruih4398eiwejdew',
        },
        {
            displayName: 'Fundamental Challenge for Java 4',
            description: '',
            language: '',
            contentType: 'Challenge',
            assignedToMe: false,
            status: 'not_started',
            url: '/app/play/challengeUuid?heruih4398eiwejdew',
        },
        {
            displayName: 'SQL Injection 5',
            description: 'Java',
            language: 'Java',
            contentType: 'Lesson',
            assignedToMe: false,
            status: 'started',
            url: '/courses/java/lessons/sql_injection',
        },
        {
            displayName: 'SQL Injection 6',
            description: 'Java',
            language: 'Java',
            contentType: 'Lesson',
            assignedToMe: false,
            status: 'started',
            url: '/courses/java/lessons/sql_injection',
        },
        {
            displayName: 'SQL Injection 7',
            description: 'Java',
            language: 'Java',
            contentType: 'Lesson',
            assignedToMe: false,
            status: 'started',
            url: '/courses/java/lessons/sql_injection',
        },
        {
            displayName: 'SQL Injection 8',
            description: 'Java',
            language: 'Java',
            contentType: 'Lesson',
            assignedToMe: false,
            status: 'started',
            url: '/courses/java/lessons/sql_injection',
        },
    ],
};
exports.default = mockSearchContent;
